import { z } from 'zod';

export const episodeSchema = z.object({
  showId: z.string().min(1, 'Izaberite emisiju'),
  title: z.string().min(2, 'Naziv mora imati najmanje 2 karaktera'),
  priority: z.enum(['NORMAL', 'HIGH', 'URGENT'], {
    message: 'Izaberite prioritet',
  }),
  scheduledDate: z.string().optional(),
  scheduledStartTime: z.string().optional(),
  scheduledEndTime: z.string().optional(),
  location: z.string().optional(),
  venue: z.string().optional(),
  scriptDeadline: z.string().optional(),
  brief: z.string().optional(),
  externalParticipants: z.array(z.string().email('Nevažeća email adresa')).optional(),
});
// Shooting days, the snimatelj/tonac pickers and the reconnaissance flags used
// to live here. They belonged to the retired EpisodeShootingDay model, which
// the planner never reads (issue #29), so scheduling happens only on
// /admin/planner now.

export type EpisodeFormData = z.infer<typeof episodeSchema>;
